import { BaseMapData } from './BaseMapData.ts';
import { StoreExpansionType, LobbyImage, ModeSettingEnum, ScenarioSettingEnum, MapSettingEnum } from '@colonist/types';
export class MapDataSS1HeadingForNewShores3P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS1HeadingForNewShores3P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.headingForNewShores',
            options: {
                count: 3
            }
        }, this.image = LobbyImage.MapSS1HeadingForNewShores3PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 22, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataSS2FourIslands3P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS2FourIslands3P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.fourIslands',
            options: {
                count: 3
            }
        }, this.image = LobbyImage.MapSS2FourIslands3PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 20, this.scenario = ScenarioSettingEnum.SS2TheFourIslands;
    }
}
export class MapDataSS3FogIslands3P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS3FogIslands3P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.fogIslands',
            options: {
                count: 3
            }
        }, this.image = LobbyImage.MapSS3FogIslands3PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 24, this.scenario = ScenarioSettingEnum.SS3TheFogIslands;
    }
}
export class MapDataSS4ThroughTheDesert3P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS4ThroughTheDesert3P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.throughTheDesert',
            options: {
                count: 3
            }
        }, this.image = LobbyImage.MapSS4ThroughTheDesert3PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 25, this.scenario = ScenarioSettingEnum.SS4ThroughTheDesert;
    }
}
export class MapDataSS1HeadingForNewShores4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS1HeadingForNewShores4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.headingForNewShores',
            options: {
                count: 4
            }
        }, this.image = LobbyImage.MapSS1HeadingForNewShores4PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 28, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataSS2FourIslands4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS2FourIslands4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.fourIslands',
            options: {
                count: 4
            }
        }, this.image = LobbyImage.MapSS2FourIslands4PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 23, this.scenario = ScenarioSettingEnum.SS2TheFourIslands;
    }
}
export class MapDataSS3FogIslands4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS3FogIslands4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.fogIslands',
            options: {
                count: 4
            }
        }, this.image = LobbyImage.MapSS3FogIslands4PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 27, this.scenario = ScenarioSettingEnum.SS3TheFogIslands;
    }
}
export class MapDataSS4ThroughTheDesert4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.SS4ThroughTheDesert4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.throughTheDesert',
            options: {
                count: 4
            }
        }, this.image = LobbyImage.MapSS4ThroughTheDesert4PPreview, this.compatibleGameModes = [
            ModeSettingEnum.Seafarers4P,
            ModeSettingEnum.Seafarers56P,
            ModeSettingEnum.CitiesAndKnightsSeafarers4P,
            ModeSettingEnum.CitiesAndKnightsSeafarers56P
        ], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 30, this.scenario = ScenarioSettingEnum.SS4ThroughTheDesert;
    }
}
// Dec 8, 2020. Jeff this is only included to define settings for Seafarers test files.
// This can be cleaned up if an actual tutorial is made
export class MapDataTutorialSS1HeadingForNewShores4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TutorialSS1HeadingForNewShores4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.tutorialHeadingForNewShores4P'
        }, this.image = LobbyImage.MapSS1HeadingForNewShores4PPreview, this.compatibleGameModes = [], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 28, this.scenario = ScenarioSettingEnum.SS1HeadingForNewShores;
    }
}
export class MapDataTutorialSS2FourIslands4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TutorialSS2FourIslands4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.tutorialFourIslands4P'
        }, this.image = LobbyImage.MapSS2FourIslands4PPreview, this.compatibleGameModes = [], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 23, this.scenario = ScenarioSettingEnum.SS2TheFourIslands;
    }
}
export class MapDataTutorialSS3FogIslands4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TutorialSS3FogIsland4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.tutorialFogIslands4P'
        }, this.image = LobbyImage.MapSS3FogIslands4PPreview, this.compatibleGameModes = [], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 27, this.scenario = ScenarioSettingEnum.SS3TheFogIslands;
    }
}
export class MapDataTutorialSS4ThroughTheDesert4P extends BaseMapData {
    constructor(...args){
        super(...args), this.premiumExpansionAccess = [
            StoreExpansionType.Seafarers4P,
            StoreExpansionType.CitiesAndKnightsSeafarers4P
        ], this.premiumMapAccess = [], this.mapEnum = MapSettingEnum.TutorialSS4ThroughTheDesert4P, this.name = {
            key: 'strings:colonistCommon.gameMaps.seafarers.tutorialThroughTheDesert4P'
        }, this.image = LobbyImage.MapSS4ThroughTheDesert4PPreview, this.compatibleGameModes = [], this.includeInFreeMapRotationIfActive = false, this.isActive = true, this.numberOfLandTiles = 30, this.scenario = ScenarioSettingEnum.SS4ThroughTheDesert;
    }
}
